import React from "react";
import { useIntl } from "react-intl";

function Company() {
  const intl = useIntl();

  return (
    <section className="company-container">
      <h1 className="company-heading">
        {intl.formatMessage({ id: "button.company" })}
      </h1>
      <div className="company-form-container">
        <p></p>
      </div>
    </section>
  );
}

export default Company;
